import { Lead } from '../@types/Lead';
import { Valuation } from '../@types/Valuation';
import { sendRequest } from './http';

const createLead = async (url: string, body: Lead) => {
  return await sendRequest<Valuation>({
    method: 'POST',
    url: `${url}/lead`,
    body,
  });
};

export default createLead;
